import { useNavigate } from "react-router-dom";
import { SectionHeading } from "@/components/site/ui";
import { MkCard } from "./MkCard";
import { useFetch } from "@/lib/useFetch";
import { ArrowRight } from "lucide-react";

export function MkRail({ kind, eyebrow, title, subtitle, limit = 4, bg = "bg-teal-900" }) {
    const nav = useNavigate();
    const { data } = useFetch(`/mk/${kind}`, []);
    return (
        <section className={`${bg} py-20`} data-testid={`rail-${kind}`}>
            <div className="container-x">
                <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
                    <SectionHeading eyebrow={eyebrow} title={title} subtitle={subtitle} />
                    <button onClick={() => nav(`/${kind}`)} className="btn-ghost-cream rounded-full px-5 py-2.5 text-sm flex items-center gap-1.5 shrink-0" data-testid={`rail-viewall-${kind}`}>View all <ArrowRight className="w-4 h-4" /></button>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {(data || []).slice(0, limit).map((it) => <MkCard key={it.slug} item={it} kind={kind} />)}
                </div>
            </div>
        </section>
    );
}
